import Header from 'component/common/layout/header/Header';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InOut } from 'types/feature/parking.type';
import FreeParkingFeeTableForSellingFacility from './FreeParkingFeeTableForSellingFacility';
import ParkingCarList from './ParkingCarList';
import styles from './ParkingContainer.module.scss';
import ParkingFeeTable from './ParkingFeeTable';
import ParkingKeypad from './ParkingKeypad';

export default function ParkingContainer() {
  const [carList, setCarList] = useState<InOut[]>([]);
  const [isShowCarList, setShowCarList] = useState(false);

  const { t } = useTranslation();

  return (
    <div className={styles.ParkingContainer}>
      <div className={styles.header_container}>
        <Header text={t('parking.parkingInformation')} />
      </div>

      {isShowCarList ? (
        /** 차량 목록  */
        <ParkingCarList carList={carList} />
      ) : (
        <div className={styles.tables}>
          {/* 주차요금 기준 */}
          <ParkingFeeTable />
          {/* 판매시설 무료 주차 */}
          <FreeParkingFeeTableForSellingFacility />
        </div>
      )}
      {/* 키패드 */}
      <ParkingKeypad setCarList={setCarList} setShowCarList={setShowCarList} />
    </div>
  );
}
